/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Monthly_DescriptionInputs */

const en_plan_monthly_description = /** @type {(inputs: Plan_Monthly_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pay as you go and cancel anytime.`)
};

const es_plan_monthly_description = /** @type {(inputs: Plan_Monthly_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paga sobre la marcha y cancela en cualquier momento.`)
};

/**
* | output |
* | --- |
* | "Pay as you go and cancel anytime." |
*
* @param {Plan_Monthly_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_monthly_description = /** @type {((inputs?: Plan_Monthly_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Monthly_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_monthly_description(inputs)
	return en_plan_monthly_description(inputs)
});